import { useState } from "react";
import classNames from "classnames";
import { HiOutlinePlay } from "react-icons/hi";

import ModalSmartStowEnableEvents from "./modals/ModalSmartStowEnableEvents";

export default function SmartStowEnableEvents({ system }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <button
                className={classNames(
                    "flex justify-center items-center gap-2 bg-white text-sm py-2 px-4 border border-sky-600 rounded",
                    "text-sky-600 hover:text-sky-950 hover:border-sky-950"
                )}
                onClick={() => setIsModalOpen(true)}
            >
                <HiOutlinePlay fontSize={24} />
                Enable Stow Events
            </button>

            <ModalSmartStowEnableEvents
                system={system}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            />
        </>
    );
}
